import { toast } from "@/components/ui/use-toast";
import {
  useExportPriceRemarkPendingItemsMutation,
  useExportPriceRemarkPendingNetworkMutation,
} from "@/services/price-remark/pending";
import {
  PendingItemsExportFilter,
  PendingNetworkFilter,
  PriceRemarkExportResult,
} from "@/services/price-remark/types";

import {
  EMAIL_PLACEHOLDER,
  PRICE_REMARK_EXPORT_MESSAGES,
} from "../constants";

function fail(description: string) {
  toast({ description, variant: "destructive" });
}

function announce(queued: PriceRemarkExportResult, emptyMessage: string) {
  if (!queued?.jobId) {
    toast({ description: emptyMessage });
    return;
  }

  toast({
    description: PRICE_REMARK_EXPORT_MESSAGES.QUEUED.replace(
      EMAIL_PLACEHOLDER,
      queued.email,
    ),
  });
}

export function useExportCollectionList() {
  const [exportNetwork, { isLoading }] =
    useExportPriceRemarkPendingNetworkMutation();

  const exportAll = async (filter: PendingNetworkFilter) => {
    try {
      const queued = await exportNetwork(filter).unwrap();
      announce(queued, PRICE_REMARK_EXPORT_MESSAGES.EMPTY_NETWORK);
    } catch {
      fail(PRICE_REMARK_EXPORT_MESSAGES.NETWORK_ERROR);
    }
  };

  return { exportAll, isExporting: isLoading };
}

export function useExportWorkOrder() {
  const [exportItems, { isLoading }] =
    useExportPriceRemarkPendingItemsMutation();

  const exportAll = async (filter: PendingItemsExportFilter) => {
    try {
      const queued = await exportItems(filter).unwrap();
      announce(queued, PRICE_REMARK_EXPORT_MESSAGES.EMPTY_ITEMS);
    } catch {
      fail(PRICE_REMARK_EXPORT_MESSAGES.ITEMS_ERROR);
    }
  };

  return { exportAll, isExporting: isLoading };
}
